export default function LeagueHeader() {
  const scrollToScoreboard = () => {
    const scoreboardSection = document.getElementById('weekly-scoreboard');
    if (scoreboardSection) {
      scoreboardSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section 
      className="relative py-20 bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('https://public.readdy.ai/ai/img_res/592dbc88132df2794eafb3e06c7235d1.jpg')`
      }}
    >
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center text-white">
          <div className="mb-8">
            <div className="w-24 h-24 bg-white rounded-full flex items-center justify-center mx-auto mb-6 p-4">
              <img 
                src="https://static.readdy.ai/image/538ca75b02212864d9ecfdf82df77bb0/c894575bb6e66422299273d3fa52e9c0.png" 
                alt="Great Golf On The Go Logo" 
                className="w-full h-full object-contain"
              />
            </div>
            <h1 className="text-5xl md:text-7xl font-bold mb-4 text-green-100">
              Mobile Simulator Golf Leagues
            </h1>
            <p className="text-xl md:text-2xl font-medium text-white mb-8">
              Great Golf On The Go Championship Series
            </p>
          </div>
          
          <p className="text-lg md:text-xl mb-8 max-w-3xl mx-auto leading-relaxed">
            Join our exciting Winter League competition featuring 4 teams battling it out over 7 weeks of intense golf simulator action. 
            Track your team's progress and compete for the championship title!
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-6">
            <button className="bg-green-600 hover:bg-green-700 text-white px-8 py-4 rounded-full font-semibold transition-colors whitespace-nowrap cursor-pointer">
              <i className="ri-trophy-line mr-2"></i>
              View Standings
            </button>
            <button 
              onClick={scrollToScoreboard}
              className="border-2 border-white text-white hover:bg-white hover:text-green-800 px-8 py-4 rounded-full font-semibold transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-calendar-line mr-2"></i>
              Schedule
            </button>
          </div>

          <div className="mt-8 bg-white/10 backdrop-blur-sm rounded-xl p-4 sm:p-6 border border-white/20 mx-2 sm:mx-0">
            <a 
              href="/spring-league-registration"
              className="inline-block bg-yellow-500 hover:bg-yellow-600 text-gray-900 px-6 sm:px-8 py-3 sm:py-4 rounded-full font-bold transition-colors cursor-pointer mb-4 text-sm sm:text-base whitespace-normal text-center"
            >
              <i className="ri-user-add-line mr-2"></i>
              Sign Up for Spring League (April-May)
            </a>
            <div className="text-white space-y-1">
              <p className="text-xs sm:text-sm font-medium">
                Please reach out via booking request, phone, e-mail, or social media to play. Hurry, limited spots available.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
